import { createDeserializer } from "@jsonapi-serde/client";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { employeeSchema } from "@/components/Forms/schema/employeeSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";

const employeeSelector = createDeserializer({
    type: "employee",
    cardinality: "one",
    attributesSchema: employeeSchema,
});

export type Employee = ReturnType<typeof employeeSelector>;

export const useFetchCurrentEmployee = (): UseQueryResult<Employee> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["current-employee"],
        queryFn: async ({ signal }) => {
            const url = apiUrl("/employee");

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: employeeSelector,
    });
};
